import  { useEffect } from "react";
import styles from "./Profile.module.scss";
import { Link } from "react-router-dom";
import { FaRegUser } from "react-icons/fa6";
import { MdOutlinePhoneCallback, MdLogout } from "react-icons/md";
import { HiOutlineMail } from "react-icons/hi";
import { IoDocumentsOutline, IoShieldCheckmarkOutline } from "react-icons/io5";
import { Avatar } from "@mui/material";
import { useSelector } from "react-redux";
import { WEBSITE_URL } from "../../utils/environment";
import { FaRegFileAlt } from "react-icons/fa";
import DashboardHeader from "../../components/Header/DashboardHeader";
import { getPhoneNo } from "../../utils/storage";

export default function Profile() {
  const { user } = useSelector((state) => state.user);

  useEffect(() => {
    if (!user) {
      window.location.href = "/";
    }
  }, [user]);

  const selectedLink = {
      about: WEBSITE_URL+'/about',
      termsCondition: WEBSITE_URL+"/terms",
      privacyPolicy: WEBSITE_URL+"/privacy",
    };

  return (
    <>
      <DashboardHeader />
      <div className={styles.profile}>
        <div className={styles.userInfo}>
          <div>
            <Avatar alt="" src="/images/avatar.png" sx={{ width: 70, height: 70 }} />
          </div>
          <div className={styles.info}>
            <h4>{user?.name}</h4>
            <p>+91 {getPhoneNo()}</p>
          </div>
        </div>
        <div className={styles.menu}>
          <h4>Contact Us</h4>
          <Link to="/contact-us">
            <MdOutlinePhoneCallback size={24} />
            <span>Call Us</span>
          </Link>
          <Link to="/contact-us">
            <HiOutlineMail size={24} />
            <span>Send E-mail</span>
          </Link>
        </div>

        <div className={styles.menu}>
          <h4>Legal</h4>
          <a href={selectedLink.about} target="_blank" rel="noopener noreferrer">
            <FaRegUser size={21} />
            <span>About Us</span>
          </a>

          <a href={selectedLink.termsCondition} target="_blank" rel="noopener noreferrer">
            <IoDocumentsOutline size={24} />
            <span>Terms & Conditions</span>
          </a>

          <a href={selectedLink.privacyPolicy} target="_blank" rel="noopener noreferrer">
            <IoShieldCheckmarkOutline size={24} />
            <span>Privacy Policy</span>
          </a>
        </div>
  <div className={styles.menu}>
          <h4>My Loans</h4>
          <Link to="/my-loan">
            <FaRegFileAlt size={21} />
            <span>View My Loans</span>
          </Link>

        </div>
        <div className={styles.menu}>
          <Link to="/logout">
            <MdLogout size={22} color="#FF0B36" />
            <span>Logout</span>
          </Link>
        </div>
      </div>
    </>
  );
}
